<template>
  <div>
    <div id="myearth" style="overflow: visible;">
      <div id="tip-layer">
        <div>
          <div id="tip-big"></div>
          <div id="tip-small"></div>
        </div>
      </div>
      <progress-bar
        v-if="completed < 100"
        :options="options"
        :value="completed"
      />
    </div>
    <!--res-->
  </div>
</template>

<script>
import resultsEarthMesh from '@/assets/results_earth_mesh'

export default {
  props: {
    companyLocation: {
      type: Object,
      required: true
    },
    chosenLocation: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    myearth: null,
    flying: false,
    plane: null,
    dashedLine: null,
    solidLine: false,
    endMarker: null,
    startMarker: null,
    X: null,
    flightScale: 1,
    overlays: [],
    completed: 0,
    options: {
      text: {
        color: '#FFFFFF',
        shadowEnable: true,
        shadowColor: '#000000',
        fontSize: 25,
        fontFamily: 'Helvetica',
        dynamicPosition: false,
        hideText: false
      },
      progress: {
        color: '#2dbd2d',
        backgroundColor: '#fafafa'
      },
      layout: {
        height: 35,
        width: 500,
        verticalTextAlign: 70,
        horizontalTextAlign: 45,
        zeroOffset: 0,
        strokeWidth: 30,
        progressPadding: 0,
        type: 'line'
      }
    }
  }),
  mounted() {
    let self = this
    this.$loadScript('/miniatureEarth2.js').then(() => {
      self.initEarth()
    })
  },
  methods: {
    initAnimation: function() {
      let self = this
      self.myearth.autoRotate = false
      self.startMarker = self.myearth.addMarker({
        color: 'red',
        color2: 'red',
        location: self.companyLocation
      })

      self.endMarker = self.myearth.addMarker({
        color: 'green',
        color2: 'green',
        location: self.chosenLocation
      })

      self.endMarker.addEventListener('mouseover', function() {
        document.getElementById('tip-layer').style.opacity = 1
        document.getElementById('tip-big').innerHTML =
          self.chosenLocation.country
        document.getElementById('tip-small').innerHTML = ''
        this.color = 'green'
      })

      self.endMarker.addEventListener('mouseout', function() {
        document.getElementById('tip-layer').style.opacity = 0
      })

      self.startMarker.addEventListener('mouseover', function() {
        document.getElementById('tip-layer').style.opacity = 1
        document.getElementById('tip-big').innerHTML =
          self.companyLocation.country
        document.getElementById('tip-small').innerHTML = ''

        this.color = 'red'
      })

      self.startMarker.addEventListener('mouseout', function() {
        document.getElementById('tip-layer').style.opacity = 0
      })
      self.plane = self.myearth.addMarker({
        mesh: 'plane',
        color: '#444',

        location: self.startMarker.location,
        scale: 0.01,
        offset: 0,
        lookAt: { lat: 0, lng: 0 },
        hotspot: false,
        transparent: true
      })
      self.myearth.goTo(self.startMarker.location, {
        duration: 200,
        relativeDuration: 300,
        approachAngle: 20
      })
      self.startFlight()
    },
    initLoader() {
      let self = this
      setTimeout(function() {
        let value = Math.floor(Math.random() * 10)
        let addOrNot = Math.floor(Math.random() * 10)
        if (addOrNot < 8.1) {
          self.completed += value
        }
        if (self.completed < 100) {
          self.initLoader()
        } else {
          self.initAnimation()
        }
      }, 300)
    },
    initEarth: function() {
      let self = this
      Earth.addMesh(resultsEarthMesh)
      self.myearth = new Earth(document.getElementById('myearth'), {
        light: 'none',
        transparent: 'true',
        mapLandColor: '#A0F8FF',
        mapSeaColor: '#eeffffcc',
        mapBorderColor: '#C4FBFF',
        mapBorderWidth: 0.4,
        location: self.chosenLocation,
        autoRotate: true,
        autoRotateSpeed: 20
      })
      self.initLoader()
    },
    startFlight() {
      let self = this
      self.flying = true

      //shrinkPins()

      var distance = Earth.getDistance(
        self.companyLocation,
        self.chosenLocation
      )
      self.flightScale = 1

      // shrink plane for short flights

      self.flightScale = 0.6 + (self.flightScale / 3000) * 0.4
      self.plane.animate('scale', 1.2 * self.flightScale)

      var flightTime = 2000 + distance

      // add target X

      self.X = self.myearth.addMarker({
        mesh: 'X',
        color: '#444',

        location: self.chosenLocation,
        scale: 0.01,
        offset: 0,
        hotspot: false
      })

      // add lines

      self.dashedLine = self.myearth.addLine({
        locations: [self.startMarker.location, self.endMarker.location],
        color: 'red',
        width: 1.25 * self.flightScale,
        offsetFlow: self.flightScale,
        dashed: true,
        dashSize: 0.25 * self.flightScale,
        dashRatio: 0.5,
        clip: 0,
        alwaysBehind: true
      })

      self.dashedLine.animate('clip', 1, { duration: 1000 + distance / 10 })

      self.solidLine = self.myearth.addLine({
        locations: [self.startMarker.location, self.endMarker.location],
        color: 'red',
        width: 1.25 * self.flightScale,
        offsetFlow: self.flightScale,
        clip: 0,
        alwaysBehind: true
      })

      // flight

      self.plane.animate(
        'lookAt',
        Earth.lerp(self.startMarker.location, self.endMarker.location, 1.0001),
        { duration: 200, relativeDuration: 100 }
      )

      self.plane.animate('offset', self.flightScale * 0.75, {
        duration: flightTime,
        easing: 'arc'
      })
      self.plane.animate('location', self.endMarker.location, {
        duration: flightTime,
        easing: 'linear',
        complete: function() {
          self.dashedLine.remove()
          self.flying = false
        }
      })

      var syncLineToPlane = function() {
        if (!self.flying) {
          self.solidLine.clip = 1
          self.myearth.removeEventListener('update', syncLineToPlane)
          return
        }

        self.dashedLine.dashOffset -= 0.001 // animate dashed line

        // calc flight progress and set line clipping

        var from = self.startMarker.object3d.position
        var to = self.endMarker.object3d.position
        var mid = self.plane.object3d.position

        var before = from.distanceTo(mid)
        var after = to.distanceTo(mid)

        var t = before / (before + after)

        self.solidLine.clip = t
      }

      self.myearth.addEventListener('update', syncLineToPlane)
    }
  }
}
</script>

<style lang="scss" scoped>
html,
body {
  margin: 0;
  padding: 0;
  background: #0e120f;
  color: white;
  font-family: sans-serif;
}
#myearth {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transition: 1s;
  overflow: hidden;
}
#myearth.earth-ready {
  transition: filter 1s ease, background 1s;
}

#myearth::before {
  content: none;
}

#glow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  background: radial-gradient(
    ellipse at center,
    rgba(157, 217, 229, 0) 33%,
    rgba(157, 217, 229, 0.07) 38.5%,
    rgba(190, 244, 255, 0.3) 51.75%,
    rgba(157, 217, 229, 0) 70%
  );
  pointer-events: none;
}

#res {
  width: 0;
  height: 0;
  overflow: hidden;
}

.pulse-overlay {
  width: 7%;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
  transform-origin: center center;
  background: radial-gradient(
    ellipse at center,
    rgba(50, 187, 255, 0.6) 0%,
    rgba(50, 187, 255, 0.2) 25%,
    rgba(50, 187, 255, 0) 70%
  );
}
.pulse-overlay::before {
  content: '';
  display: block;
  padding-top: 100%;
}

.pulse-now {
  opacity: 1;
}
.earth-occluded.pulse-now {
  opacity: 0.5;
}
div.animation-content {
  transform: none;
  transition: 0;
}

#tip-layer {
  position: absolute;
  width: 100%;

  background-color: #ffffffaa;
  backdrop-filter: blur(10px);
  border-radius: 100px;
  color: #444;
  text-shadow: 0 0 10px #00000022;
  user-select: none;
  pointer-events: none;
  z-index: 5000;
  transition: opacity 0.25s ease;
  opacity: 0;
  top: 70%;

  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  text-align: center;
}

#tip-big {
  font-size: 3em;
  letter-spacing: 0.05em;
}
#tip-small {
  font-size: 27px !important;
  margin-top: -10px;
  margin-bottom: 10px;
}
</style>
<style lang="scss">
.progress-bar {
  max-width: 400px;
  position: absolute;
  top: 50%;
  right: 50%;
  width: 100% !important;
  transform: translate(50%, 50%);
  z-index: 1001;
}
#line-progress {
  box-shadow: 0 0 40px #01bece;
  border-radius: 50px;
  opacity: 0.9;
  width: 100% !important;

  line:nth-child(2) {
    stroke: #01bece;
  }
}
</style>
